'use strict'

var powers = 0

exports.boolean = increment()
exports.booleanish = increment()
exports.overloadedBoolean = increment()
exports.number = increment()
exports.spaceSeparated = increment()
exports.commaSeparated = increment()
exports.commaOrSpaceSeparated = increment()

function increment() {
  return Math.pow(2, ++powers)
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/types.js
// module id = 52
// module chunks = 33019919093843 87034247430840 144482056661899